module.exports = __webpack_public_path__ + "static/vinyard2-afb2620e9b62b53040576b131dd74eec.jpg";